import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import GeomanistRegular from "./assets/Geomanist-Regular.woff2";

let baseTheme = createTheme({
  palette: {
    background: {
      default: "#000", // black
    },
    primary: {
      main: "#A97D58", // Sidebar color
    },
    secondary: {
      main: "#E3E3DC", // Conversation panel color
    },
  },
  typography: {
    fontFamily: ["Geomanist"].join(","),
    button: {
      textTransform: "none",
    },
  },
});

// Extend the theme with component overrides that use the palette
baseTheme = createTheme(baseTheme, {
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'Geomanist';
          src: url(${GeomanistRegular}) format('woff2');
          font-weight: 400;
          font-style: normal;
          ascent-override: 92%;
          descent-override: 30%;
        }
      `,
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          backgroundColor: baseTheme.palette.primary.main, // row background
        },
        cell: {
          color: "#000", // optional: cell text color
          border: "0.5px solid #000", // row cell borders
        },
      },
    },
  },
});

const mainTheme = responsiveFontSizes(baseTheme);
export default mainTheme;
